"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
const react_image_size_1 = require("react-image-size");
const clsx_1 = __importDefault(require("clsx"));
const Input_1 = require("../../../../ui/Fields/Input/Input");
const Button_1 = __importDefault(require("../../../../ui/Button/Button"));
const LinkOff_1 = __importDefault(require("@mui/icons-material/LinkOff"));
const InsertLinkRounded_1 = __importDefault(require("@mui/icons-material/InsertLinkRounded"));
const Extensions_1 = require("../../../../Extensions/Extensions");
const validation_1 = require("../../../../utils/validation");
const Tabs_1 = require("../../../../ui/Tabs/Tabs");
const ResourceBrowserSelector_1 = require("../../../../ui/Fields/ResourceBrowserSelector/ResourceBrowserSelector");
var ViewTypes;
(function (ViewTypes) {
    ViewTypes["Resource"] = "Resource";
    ViewTypes["URL"] = "URL";
})(ViewTypes || (ViewTypes = {}));
const imageTypeOptions = {
    [ViewTypes.Resource]: { label: 'From source' },
    [ViewTypes.URL]: { label: 'From URL' },
};
const ImageForm = ({ data, onSubmit }) => {
    const { control, register, handleSubmit, setValue, watch, formState: { errors }, } = (0, react_hook_form_1.useForm)({
        defaultValues: data,
    });
    const imageType = watch('imageType');
    const [viewType, setViewType] = (0, react_1.useState)(ViewTypes.Resource);
    const [aspectRatioFromWidth, setAspectRatioFromWidth] = (0, react_1.useState)(9 / 16);
    const [aspectRatioFromHeight, setAspectRatioFromHeight] = (0, react_1.useState)(16 / 9);
    const [aspectRatioLocked, setAspectRatioLocked] = (0, react_1.useState)(true);
    const setDimensionsFromURL = async (e) => {
        try {
            const { width, height } = await (0, react_image_size_1.getImageSize)(e.target.value);
            setValue('image.width', width);
            setValue('image.height', height);
            setAspectRatioFromWidth(height / width);
            setAspectRatioFromHeight(width / height);
        }
        catch (error) {
            // swallow the error for fetching the image size, will occur if the URL does not point to an image.
            // will be handled by validation when attempting to add the image.
        }
    };
    const validateIsNotImage = async (src) => {
        try {
            await (0, react_image_size_1.getImageSize)(src);
            return false;
        }
        catch (error) {
            return true;
        }
    };
    const calculateDimensions = (event) => {
        if (aspectRatioLocked) {
            const currentTarget = event?.target;
            const type = currentTarget.name;
            const currentValue = currentTarget.value;
            const otherValue = type === 'image.width' ? 'image.height' : 'image.width';
            const aspectRatio = type === 'image.width' ? aspectRatioFromWidth : aspectRatioFromHeight;
            const newValue = Math.round(aspectRatio * Number(currentValue) * 100) / 100;
            setValue(otherValue, newValue);
        }
    };
    const toggleAspectRatio = () => {
        setAspectRatioLocked(!aspectRatioLocked);
    };
    (0, react_1.useEffect)(() => {
        if (imageType === Extensions_1.NodeName.Image) {
            setViewType(ViewTypes.URL);
        }
        else {
            setViewType(ViewTypes.Resource);
        }
    }, [imageType, setViewType]);
    const handleChangeViewType = (0, react_1.useCallback)((value) => {
        setViewType(value);
        // If its the URL field type we know what the imageType should be
        if (value === ViewTypes.URL) {
            setValue('imageType', Extensions_1.NodeName.Image);
        }
        else {
            // Need a value here and this is the assumed default elsewhere
            // Will be set again later once Resource Browser returns a resource value
            setValue('imageType', Extensions_1.NodeName.AssetImage);
        }
    }, [setViewType, setValue]);
    return (react_1.default.createElement("form", { className: "squiz-fte-form", onSubmit: handleSubmit(onSubmit) },
        react_1.default.createElement("div", { className: "squiz-fte-form-group mb-4" },
            react_1.default.createElement(Tabs_1.Tabs, { value: imageType === Extensions_1.NodeName.Image ? ViewTypes.URL : ViewTypes.Resource, options: imageTypeOptions, onChange: handleChangeViewType })),
        viewType === ViewTypes.URL && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "squiz-fte-form-group mb-2" },
                react_1.default.createElement(Input_1.Input, { label: "Source", required: true, error: errors?.image?.src?.message, ...register('image.src', {
                        onChange: setDimensionsFromURL,
                        required: 'Source is required',
                        validate: {
                            isValidImage: async (value) => {
                                if (value && validation_1.regexDataURI.test(value)) {
                                    return 'Must not be a data URI';
                                }
                                if (value && (await validateIsNotImage(value))) {
                                    return 'Must be a valid image URL';
                                }
                            },
                            noEmptySpaces: validation_1.noEmptySpacesValidation,
                        },
                    }) })),
            react_1.default.createElement("div", { className: "flex flex-row" },
                react_1.default.createElement("div", { className: "squiz-fte-form-group mb-2" },
                    react_1.default.createElement(Input_1.Input, { label: "Width", type: "number", required: true, error: errors?.image?.width?.message, ...register('image.width', {
                            onChange: calculateDimensions,
                            required: 'Width is required',
                            validate: {
                                isValidWidth: (value) => {
                                    if (value && !(value > 0)) {
                                        return 'Must be higher than 0';
                                    }
                                },
                            },
                        }) })),
                react_1.default.createElement("div", { className: "flex mx-1 mb-2" },
                    react_1.default.createElement(Button_1.default, { handleOnClick: toggleAspectRatio, isActive: false, icon: aspectRatioLocked ? react_1.default.createElement(InsertLinkRounded_1.default, null) : react_1.default.createElement(LinkOff_1.default, null), label: "Constrain properties", isDisabled: false, className: (0, clsx_1.default)('my-auto', !errors?.image?.height && !errors?.image?.width && 'mb-0') })),
                react_1.default.createElement("div", { className: "squiz-fte-form-group mb-2" },
                    react_1.default.createElement(Input_1.Input, { label: "Height", type: "number", required: true, error: errors?.image?.height?.message, ...register('image.height', {
                            onChange: calculateDimensions,
                            required: 'Height is required',
                            validate: {
                                isValidHeight: (value) => {
                                    if (value && !(value > 0)) {
                                        return 'Must be higher than 0';
                                    }
                                },
                            },
                        }) }))),
            react_1.default.createElement("div", { className: "squiz-fte-form-group mb-2" },
                react_1.default.createElement(Input_1.Input, { label: "Alternative description", error: errors?.image?.alt?.message, ...register('image.alt') })))),
        viewType === ViewTypes.Resource && (react_1.default.createElement("div", { className: "squiz-fte-form-group mb-2" },
            react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: "resourceImage", rules: {
                    validate: (value) => {
                        const matrixValidation = (0, validation_1.hasProperties)('An image must be selected', [
                            'matrixIdentifier',
                            'matrixAssetId',
                        ])(value);
                        const damValidation = (0, validation_1.hasProperties)('An image must be selected', [
                            'damObjectId',
                            'damSystemIdentifier',
                        ])(value);
                        // One of the two needs to validate
                        return matrixValidation && damValidation;
                    },
                }, render: ({ field: { onChange, value }, fieldState: { error } }) => (react_1.default.createElement(ResourceBrowserSelector_1.ResourceBrowserSelector, { modalTitle: "Insert image", allowedTypes: ['image'], value: value, onChange: (value) => {
                        setValue('imageType', value.target.value.nodeType);
                        onChange(value);
                    }, error: error?.message })) })))));
};
exports.default = ImageForm;
